import { useState, useEffect } from 'react';
import useTranscriptCorrector from './useTranscriptCorrector';
import { API_ENDPOINTS } from 'constants';
import { useFetchData } from './apiHooks';

const useSpeechToText = (locale, autoReset=true) => {
    const [transcript, setTranscript] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [error, setError] = useState('');
    const { data, isLoading, error: errorTermCorrections, refetch } = useFetchData(API_ENDPOINTS.TERM_CORRECTIONS.LIST);
    const corrections = data?.items?.reduce((acc, item) => {
        acc[item.original.trim().toLowerCase()] = item.corrected;
        return acc;
    }, {});

    const { correctTranscript } = useTranscriptCorrector(corrections, 2);
    
    useEffect(() => {
        //console.log('use effect in use speeche to text')
        // Check for browser support
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            setError('Speech recognition not supported in this browser.');
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = locale;

        recognition.onstart = () => setIsListening(true);
        recognition.onend = () => setIsListening(false);

        recognition.onresult = (event) => {
            const currentTranscript = Array.from(event.results)
                .map(result => result[0])
                .map(result => result.transcript)
                .join('');
            const correctedTranscript = correctTranscript(currentTranscript, corrections);
            setTranscript(transcript + ' ' + correctedTranscript);
        };
        

        recognition.onerror = (event) => {
            setError(event.error);
        };

        if (isListening) {
            recognition.start();
        } else {
            recognition.stop();
        }

        return () => {
            recognition.stop();
        };
    }, [isListening, locale]);

    const startListening = () => setIsListening(true);

    const stopListening = () => {
        setIsListening(false);
        autoReset && setTranscript(''); // Reset the transcript when stopping the listening
    };

    const toggleListening = () => {
        if (isListening) {
                stopListening();
        } else {
                startListening();
        }
    };

    return {
        transcript,
        isListening,
        error,
        startListening,
        stopListening,
        setTranscript,
        toggleListening
    };
};

export default useSpeechToText;
